import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './order-form-header.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
var OrderFormHeader = function OrderFormHeader(_ref) {
  var children = _ref.children,
    title = _ref.title,
    intro = _ref.intro,
    _ref$iconClassName = _ref.iconClassName,
    iconClassName = _ref$iconClassName === void 0 ? 'fa-list-ol' : _ref$iconClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "order-form-header ".concat(className)
  }, children, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "fontawesome-icon float-start",
    icon: "fa-soild ".concat(iconClassName)
  }), /*#__PURE__*/React.createElement("div", {
    className: "ps-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "my-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: title
  })), /*#__PURE__*/React.createElement(T.md, {
    source: intro
  })));
};
export default OrderFormHeader;